const isLocal = process.env.REACT_APP_IS_LOCAL === 'true';

const API_URL = isLocal
  ? (process.env.REACT_APP_API_PORT ? `http://localhost:${process.env.REACT_APP_API_PORT}` : 'http://localhost:5000')
  : 'https://titaton.runit-dev.fr';

export { isLocal, API_URL };
